import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f93b7d76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6 ModelField-colFirst" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_5 = { class: "col-2 ModelField-col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, [
  /*#__PURE__*/_createTextVNode("Объем (м"),
  /*#__PURE__*/_createElementVNode("sup", null, "3"),
  /*#__PURE__*/_createTextVNode(")")
], -1))
const _hoisted_7 = { class: "col-2 ModelField-col" }
const _hoisted_8 = { class: "ModelField-label" }
const _hoisted_9 = { class: "col-2 ModelField-colLast" }
const _hoisted_10 = { class: "ModelField-label" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-2 ModelField-colFirst" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, [
  /*#__PURE__*/_createTextVNode(" Погруженный объем (м"),
  /*#__PURE__*/_createElementVNode("sup", null, "3"),
  /*#__PURE__*/_createTextVNode(") ")
], -1))
const _hoisted_14 = { class: "col-2 ModelField-col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Мин. толщина доски (мм)", -1))
const _hoisted_16 = { class: "col-2 ModelField-col" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Мин. ширина доски (мм)", -1))
const _hoisted_18 = { class: "col-2 ModelField-col" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Макс. толщина доски (мм)", -1))
const _hoisted_20 = { class: "col-2 ModelField-col" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Макс. ширина доски (мм)", -1))
const _hoisted_22 = { class: "col-2 ModelField-colLast" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Кол-во контейнеров (шт)", -1))
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col PlanOrderNomenclatureCreateEditDialog_subTableFirstColumn" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Ограничения по свойствам панелей (И)", -1))
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "col PlanOrderNomenclatureCreateEditDialog_subTableSecondColumn" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Объемные ограничения по длине доски (И)", -1))
const _hoisted_30 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    ref: "dialog",
    onOnShown: _ctx.onShown,
    height: "90vh",
    "max-width": "1200px"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_TextControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              placeholder: "Наименование...",
              "show-clear-button": true,
              value: model.name,
              "onUpdate:value": ($event: any) => ((model.name) = $event),
              validationGroup: validationGroup
            }, null, 8, ["value", "onUpdate:value", "validationGroup"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_DecimalControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              value: model.volume,
              "onUpdate:value": ($event: any) => ((model.volume) = $event),
              hasEmptyValue: false,
              decimalPoints: 3,
              step: 1,
              min: 0
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.marginMinTitle), 1),
            (_ctx.marginUnitInPercent)
              ? (_openBlock(), _createBlock(_component_IntegerControl, {
                  key: 0,
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  value: model.marginMin,
                  "onUpdate:value": ($event: any) => ((model.marginMin) = $event),
                  hasEmptyValue: false,
                  step: 1,
                  min: 0
                }, null, 8, ["value", "onUpdate:value"]))
              : (_openBlock(), _createBlock(_component_DecimalControl, {
                  key: 1,
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  value: model.marginMin,
                  "onUpdate:value": ($event: any) => ((model.marginMin) = $event),
                  hasEmptyValue: false,
                  decimalPoints: 3,
                  step: 0.001
                }, null, 8, ["value", "onUpdate:value", "step"]))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.marginTitle), 1),
            (_ctx.marginUnitInPercent)
              ? (_openBlock(), _createBlock(_component_IntegerControl, {
                  key: 0,
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  value: model.margin,
                  "onUpdate:value": ($event: any) => ((model.margin) = $event),
                  hasEmptyValue: false,
                  step: 1,
                  min: 0
                }, null, 8, ["value", "onUpdate:value"]))
              : (_openBlock(), _createBlock(_component_DecimalControl, {
                  key: 1,
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  value: model.margin,
                  "onUpdate:value": ($event: any) => ((model.margin) = $event),
                  hasEmptyValue: false,
                  decimalPoints: 3,
                  step: 0.001
                }, null, 8, ["value", "onUpdate:value", "step"]))
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_DecimalControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              value: model.shippedVolume,
              "onUpdate:value": ($event: any) => ((model.shippedVolume) = $event),
              hasEmptyValue: false,
              decimalPoints: 3,
              step: 1,
              min: 0
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              hasEmptyValue: true,
              min: 0,
              value: model.minBoardHeight,
              "onUpdate:value": ($event: any) => ((model.minBoardHeight) = $event)
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              hasEmptyValue: true,
              min: 0,
              value: model.minBoardWidth,
              "onUpdate:value": ($event: any) => ((model.minBoardWidth) = $event)
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              hasEmptyValue: true,
              min: 0,
              value: model.maxBoardHeight,
              "onUpdate:value": ($event: any) => ((model.maxBoardHeight) = $event)
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              hasEmptyValue: true,
              min: 0,
              value: model.maxBoardWidth,
              "onUpdate:value": ($event: any) => ((model.maxBoardWidth) = $event)
            }, null, 8, ["value", "onUpdate:value"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_IntegerControl, {
              class: "ModelField-control",
              stylingMode: "outlined",
              hasEmptyValue: true,
              min: 0,
              value: model.containerCount,
              "onUpdate:value": ($event: any) => ((model.containerCount) = $event)
            }, null, 8, ["value", "onUpdate:value"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", { id: _ctx.nomenclatureConstraintSubGridDomId }, null, 8, _hoisted_27)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", { id: _ctx.nomenclatureVolumeConstraintSubGridDomId }, null, 8, _hoisted_30)
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback", "onOnShown"]))
}